<template>
    <v-container>
   <v-expansion-panels v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header>Registros de Eventos</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table :headers="headers" :items="eventos" class="elevation-1">
              <template v-slot:item="{ item }">
                <tr>
                  <td class="hide-column">{{ item.ApiEvent_id }}</td>
                  <td>{{ item.EventTitle }}</td>
                  <td>{{ truncateDescription(item.Description) }}</td>
                  <td>{{ item.StartDate_Dt }}</td>
                  <td>{{ item.EndDate_Dt }}</td>
                  <td>{{ item.Active }}</td>
                  <td>{{ item.Priority }}</td>
                  <td>{{ item.LastOpRepUser_id }}</td>
                  <td>{{ item.RepEvent_Dttm }}</td>
                  <td>
                    <v-btn icon @click="prepararEdicion(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
  
                  </td>
                  <td>
                    <v-btn icon color="red" @click="eliminarEvento(item.ApiEvent_id)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-btn :disabled="loading" color="primary" @click="cargarEventos">
              Refrescar
            </v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
  
        <v-expansion-panel>
          <v-expansion-panel-header>Formulario de Eventos</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form ref="form" v-model="valid">
              <v-text-field label="Título del Evento" v-model="evento.EventTitle" :rules="[v => !!v || 'El título es obligatorio']" required ></v-text-field>
              <v-textarea label="Descripción" v-model="evento.Description" :rules="[v => !!v || 'La descripción es obligatoria']" required ></v-textarea>
              
              <v-row>
                <v-col cols="12" sm="6" md="4">
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="evento.StartDate_Dt" label="Fecha de Inicio" readonly v-on="on" :rules="[v => !!v || 'La fecha de inicio es obligatoria']" required ></v-text-field>

                    </template>
                    <v-date-picker v-model="evento.StartDate_Dt" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="evento.EndDate_Dt" label="Fecha Fin" readonly v-on="on" :rules="[v => !!v || 'La fecha fin es obligatoria']" required ></v-text-field>
                    </template>
                    <v-date-picker v-model="evento.EndDate_Dt" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                </v-row>
                <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                  v-model="evento.Priority"
                  :items="priorities"
                  item-text="text"
                  item-value="value"
                  label="Prioridad"
                  :rules="[v => !!v || 'La prioridad es obligatoria']"
                  required
                ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-checkbox v-model="evento.Active" label="Activar y Enviar"></v-checkbox>
                </v-col>
                </v-row>

              <v-row>
                <v-col cols="12">
                <!--  <v-btn color="primary" @click="crearEvento">Crear</v-btn>  -->
                  <v-btn color="primary" @click="guardarEvento">{{ editMode ? 'Actualizar' : 'Crear' }}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-dialog v-model="loading" persistent width="700" height="800">
          <v-card>
            <v-card-text class="text-center">
              Cargando, por favor espere...
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="loadingEliminacion" persistent max-width="290px">
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn v-if="mostrarCerrar" icon @click="cerrarDialogoEliminacion">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="text-center">
              {{ mensajeEliminacion }}
              <v-progress-circular
                v-if="mostrarCargando"
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="loadingCreation" persistent max-width="290px">
          <v-card>
            <v-card-text class="text-center">
              {{ mensajeCreacion }}
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-card-text>
          </v-card>
        </v-dialog>

  
      </v-expansion-panels>
    </v-container>
  </template>
  
    
    
    <script>
    import axios from 'axios';
    
    export default {
      data: () => ({
        api_tool_url: process.env.VUE_APP_API_TOOL_URL,
        loading: false,
        loadingEliminacion: false,
        mensajeEliminacion: '',
        mostrarCargando: true,
        mostrarCerrar: false,
        currentEventId: null,
        loadingCreation: false,
        mensajeCreacion: '',
        priorities: [
            { text: 'Alta', value: 1 },
            { text: 'Media', value: 2 },
            { text: 'Baja', value: 3 }
        ],
        valid: false,
        config: {
          headers: {
            // 'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
          }
        },
        evento: {
         EventTitle: '',
         Description: '',
         StartDate_Dt: null,
         EndDate_Dt: null,
         Active: false,
         Priority: null
        },
        eventos: [],
        headers: [
          { text: 'ID del Evento', value: 'ApiEvent_id', class: 'hide-column' },
          { text: 'Título', value: 'EventTitle' },
          { text: 'Descripción', value: 'Description' },
          { text: 'Fecha de Inicio', value: 'StartDate_Dt' },
          { text: 'Fecha Fin', value: 'EndDate_Dt' },
          { text: 'Activo', value: 'Active' },
          { text: 'Prioridad', value: 'Priority' },
          { text: 'Usuario', value: 'LastOpRepUser_id' },
          { text: 'Fecha de Evento', value: 'RepEvent_Dttm' },
          { text: 'Editar', value: 'actions', sortable: false },
        { text: 'Eliminar', value: 'actions', sortable: false }
        ],
        menu: false,
        menu2: false,
        panel: 0
      }),
      mounted() {
        this.cargarEventos();
      },
      methods: {
        guardarEvento() {
          if (this.$refs.form.validate()) { 
            if (this.editMode) {
              this.editarEvento();
            } else {
              this.crearEvento();
            }
          }
        },
        truncateDescription(description) {
          if (description && description.length > 50) {
            return description.substring(0, 50) + '...';
          }
          return description;
        },
        crearEvento() {
          const data = {
            EventTitle: this.evento.EventTitle,
            Description: this.evento.Description,
            StartDate_Dt: this.evento.StartDate_Dt,
            EndDate_Dt: this.evento.EndDate_Dt,
            Active: this.evento.Active,
            Priority: this.evento.Priority,
            ApiUser_id: sessionStorage.getItem('ApiUser_id')
          };
          this.mensajeCreacion = 'Creando registro...';
          this.loadingCreation = true;
    
          axios.post(this.api_tool_url + '/CrearEvento', data, this.config)
          .then(response => {
              alert('Creado con éxito');
              this.evento = { EventTitle: '', Description: '', StartDate_Dt: null, EndDate_Dt: null, Active: false, Priority: null};
          })
          .catch(error => {
              alert('Error al crear registro: ' + error.message);
          })
          .finally(() => {
            this.loadingCreation = false;
            //this.cargarEventos();
          });
        },
        cargarEventos() {
          this.loading = true;
          axios.get(this.api_tool_url + '/getEvents', this.config)
          .then(response => {
            
            this.eventos = response.data.map(evento => ({
          ...evento,
          StartDate_Dt: this.formatDate(evento.StartDate_Dt),
          EndDate_Dt: this.formatDate(evento.EndDate_Dt),
          RepEvent_Dttm: this.formatDateTime(evento.RepEvent_Dttm),
          Active: this.formatActive(evento.Active),
          Priority: this.mapeoDescriptionPriority(evento.Priority) 

        }));
          })
          .catch(error => {
            console.error('Error al cargar:', error);
            alert('Error al cargar: ' + error.message);
          })
          .finally(() => {
          this.loading = false;
        });
        },
        formatDate(dateString) {
          const date = new Date(dateString.includes('T') ? dateString : `${dateString}T00:00:00Z`);
          if (!isNaN(date.getTime())) {
              let day = ('0' + date.getUTCDate()).slice(-2); 
              let month = ('0' + (date.getUTCMonth() + 1)).slice(-2); 
              let year = date.getUTCFullYear(); 
              return `${year}-${month}-${day}`;
          }
          return dateString; 
        },

  
        formatDateTime(dateString) {
            const date = new Date(dateString.includes('T') ? dateString : `${dateString}T00:00:00Z`);
            if (!isNaN(date.getTime())) {
                let day = ('0' + date.getUTCDate()).slice(-2); 
                let month = ('0' + (date.getUTCMonth() + 1)).slice(-2); 
                let year = date.getUTCFullYear(); 
                let hours = ('0' + date.getUTCHours()).slice(-2); 
                let minutes = ('0' + date.getUTCMinutes()).slice(-2);
                let seconds = ('0' + date.getUTCSeconds()).slice(-2);
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
            return dateString;
        },

        formatActive(activeString) {
          console.log("Valor recibido para 'Active':", activeString);
          if (activeString == '1') { 
              activeString = 'Si';
          }
          else
          {
            activeString = 'No';
          }
          return activeString; 
        },
        mapeoDescriptionPriority(priorityNumber) {
            const priorities = {
            1: 'Alta',
            2: 'Media',
            3: 'Baja'
            };
            return priorities[priorityNumber] || 'Desconocido';
        },
        
        prepararEdicion(item) {
          this.editMode = true;
          this.currentEventId = item.ApiEvent_id;
          this.evento.EventTitle = item.EventTitle;
          this.evento.Description = item.Description;
          this.evento.StartDate_Dt = item.StartDate_Dt;
          this.evento.EndDate_Dt = item.EndDate_Dt;
          this.evento.Active = item.Active === 'Si';
         
          if (item.Priority == 'Alta') {
            this.evento.Priority = 1;
          }
          if (item.Priority == 'Media') {
            this.evento.Priority = 2;
          }
          if (item.Priority == 'Baja') {
            this.evento.Priority = 3;
          }
          this.panel = 1;
        },
  
        editarEvento() {
          const data = {
            ApiEvent_id: this.currentEventId,
            EventTitle: this.evento.EventTitle,
            Description: this.evento.Description,
            StartDate_Dt: this.evento.StartDate_Dt,
            EndDate_Dt: this.evento.EndDate_Dt,
            Active: this.evento.Active,
            Priority: this.evento.Priority,
            ApiUser_id: sessionStorage.getItem('ApiUser_id')
          };

          this.mensajeCreacion = 'Actualizando registro...';
          this.loadingCreation = true;
          
          axios.post(this.api_tool_url + '/CrearEvento', data, this.config)
          //axios.put(`${this.api_tool_url}/ActualizarEvento/${this.currentEventId}`, data, this.config)
            .then(response => {
              alert('Evento actualizado con éxito');
              this.cargarEventos();
              this.limpiarFormulario();
            })
            .catch(error => {
              alert('Error al actualizar el evento: ' + error.message);
            })
            .finally(() => {
              this.loadingCreation = false;
              //this.cargarEventos();
      });
        },
  
        limpiarFormulario() {
          this.evento = { EventTitle: '', Description: '', StartDate_Dt: null, EndDate_Dt: null, Active: false, Priority: null };
          this.editMode = false;
          this.currentEventId = null;
        },
  
        eliminarEvento(apiEventId) {
          if (confirm("¿Estás seguro de querer eliminar este registro?")) {
            this.mensajeEliminacion = 'Eliminando registro...';
            this.mostrarCargando = true;
            this.mostrarCerrar = false;
            this.loadingEliminacion = true;
            axios.post(`${this.api_tool_url}/eliminaEvento`, { apiEventId: apiEventId }, this.config)
              .then(response => {
                if(response.status  == 200) {
                  this.mensajeEliminacion = 'Eliminado con éxito';
                  this.cargarEventos();
                  setTimeout(() => {
                    this.loadingEliminacion = false; 
                  }, 2000); 
                } else {
                  this.mensajeEliminacion = 'Error al eliminar: ' + response.error;
                  this.mostrarCerrar = true; 
                }
              })
              .catch(error => {
                this.mensajeEliminacion = 'Error al eliminar: ' + error.message;
                this.mostrarCerrar = true; 
              })
              .finally(() => {
                this.mostrarCargando = false;
              });
          }
    },
    cerrarDialogoEliminacion() {
      this.loadingEliminacion = false;
      this.mostrarCerrar = false;
    }
  
  
        
      }
    }
    </script>
  
  <style>
  .hide-column {
    display: none;
  }
  </style>
    


// WEBPACK FOOTER //
// src/components/CreateEventGrid.vue